export default "__VITE_ASSET__BvQ7CrjN__"